import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    boxCenter: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginTop: "1.2rem",
    },
    box: {
        display: "block",
        width: "90vw",
        height: "65vh",
        justifyContent: "center",
        alignItems: "center",
    },
    boxPrancheta: {
        height: "65vh",
        backgroundColor: "white",
        display: "flex",
        width: "90vw",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
    },
    dashboard_header: {
        padding: "20px",
        display: "flex",
        width: "100%",
        backgroundColor: "#AED6F1",
        gap: "10px",
        justifyContent: "space-between",
        flexWrap: "wrap",
        minHeight: "80px",
    },
    circleRed: {
        display: "inline-block",
        width: "20px",
        height: "20px",
        backgroundColor: "red",
        borderRadius: "50%",
    },
    site: {
        marginLeft: "20px",
        width: "300px",
    },

    center_data: {
        display: "flex",
        justifyContent: "space-between",
        alignContent: "center",
        alignItems: "baseline",
        flexDirection: "row",
        flexWrap: "wrap",
        //minWidth: "400px",
        gap: "8px",
    },
    dashboard_header_description: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "max-width": "100px",
    },
    dashboard_header_status: {
        display: "flex",
        //"max-width": "600px",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "row",
        flexWrap: "wrap",
    },
    dashboard_header_filtro: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignContent: "center",
        height: "100%",
        alignItems: "center",
        gap: "8px",
    },
    dashboard_header_filtro_1: {
        display: "flex",
        "flex-direction": "row",
        "align-items": "baseline",
    },
    dashboard_content: {
        display: "flex",
        flexDirection: "row",
        //    border: '1px solid green',
        justifyContent: "space-between",
        alignItems: "center",
    },
    boxDataGrid: {
        width: "100%",
        height: "65vh",
        backgroundColor: "white",
        "& .header_grid": {
            backgroundColor: "#2471A3",
            color: "white",
        },
        "& .MuiDataGrid-row.Mui-even:not(:hover)": {
            backgroundColor: "#D6EAF8",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-odd:not(:hover)": {
            backgroundColor: "#93b7d9",
            color: "black",
        },
        "& .MuiDataGrid-row.Mui-selected:not(:hover)": {
            backgroundColor: "#999999",
            color: "white",
        },
        "& .MuiDataGrid-row.Mui-selected:hover": {
            backgroundColor: "#999999",
            color: "white",
        },
        "& .MuiDataGrid-row:hover": {
            backgroundColor: "#999999",
            color: "white",
        },
    },
    side_content: {
        display: "grid",
        overflow: "auto",
    },
    radio_group_custom: {
        fontSize: "15px",
        label: {
            fontSize: "0.8em",
        },
        MuiFormControlLabel: {
            label: {
                fontSize: "0.8em",
            },
        },
        checkboxLabel: {
            fontSize: "15px",
        },
    },
    header_grid: {
        backgroundColor: "black",
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    fab: {
        position: "absolute",
        bottom: "8vh",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));
